/* eslint-disable prefer-destructuring */
import React, { useContext, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, DropdownButton, Image } from 'react-bootstrap'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faReply } from '@fortawesome/free-solid-svg-icons'
import { AuthContext } from './ContextProvider'
import Avatar from './Avatar'
import MenuCard from './MeunCard'
import { logoFull } from '../asset'

function SideNavBar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { auth, setAuth } = useContext(AuthContext)

  const isInDraft = useMemo(
    () => location.pathname.includes('/insights'),
    [location]
  )

  return auth.authed && !isInDraft ? (
    <div
      className="w-100 h-100 d-flex flex-column border py-3 ps-2"
      style={{
        backgroundColor: '#eeeeee',
      }}
    >
      <div className="mb-2">
        <Image src={logoFull} width="80" />
      </div>
      <div
        title={auth.email}
        className="App-oneLineEllipsis px-3 small fw-bold pb-3 text-secondary"
      >
        {/* {auth.name} */}
        {auth.email}
      </div>
      {(auth.setting.admin
        ? [
            { label: '主頁', link: '/mainpage' },
            { label: '創意版位', link: '/' },
            // { label: '素材', link: '/material' },
            { label: '容器', link: '/ContainerManager' },
            { label: 'Revive報表', link: '/report' },
            { label: '360報表', link: '/AdManagerReportForm' },
            { label: 'ＣＳ', link: '/creator' },
          ]
        : [
            { label: '主頁', link: '/mainpage' },
            { label: '創意版位', link: '/' },
          ]
      ).map(({ label, link }) => (
        <Button
          key={link}
          active={location.pathname === link}
          disabled={location.pathname === link}
          onClick={() => navigate(link)}
          className="w-75 mx-auto my-2 text-nowrap"
          variant="outline-dai"
          size="sm"
        >
          {label}
        </Button>
      ))}
      {false && (
        <div className="h-15 mb-4">
          <DropdownButton
            id="dropdown-button-drop-end"
            drop="end"
            className="h-100 w-100"
            title={
              <div className="text-dai fw-bolder pt-3">
                <div
                  style={{
                    height: '50px',
                  }}
                >
                  <Avatar />
                </div>
                {auth.name}
              </div>
            }
          >
            <MenuCard />
          </DropdownButton>
        </div>
      )}
      <Button
        onClick={() => {
          document.cookie = `token=; Domain=${window.location.hostname}; Path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`
          setAuth({
            authed: false,
          })
          window.location.replace('/')
        }}
        className={`w-70 mx-auto ${isInDraft ? '' : 'mt-auto'} my-2`}
        variant="outline-dai"
        size="sm"
      >
        登出
      </Button>
    </div>
  ) : (
    <div />
  )
}

export default SideNavBar
